module.exports = __webpack_public_path__ + "static/img/mask_big.ee11ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/mask_big.jpg
// module id = Gozj
// module chunks = 0